
export const RECEIVED_GAMES = "RECEIVED_GAMES";


export const receivedGames = json => ({
    type: RECEIVED_GAMES,
    games: json.games,
});

export const fetchGames = () => dispatch => {
    return fetch('https://civ.local.devananderic.com/backend/api/fetch_games')
        .then(
            response => response.json(),
            error => console.log('An error occurred.', error),
        )
        .then((json) => {
            dispatch(receivedGames(json));
        },
        );
};

export const logEvent = (event_name, event_data) => dispatch => {
    return fetch('https://civ.local.devananderic.com/backend/api/log_event', {
        method: 'POST',
        mode: 'no-cors',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "events": [
                {
                    "event_name": event_name,
                    "time": Date.now(),
                    "data": event_data
                }]
        }) // body data type must match "Content-Type" header
    })
        .then(
            response => response.json(),
            error => console.log('An error occurred.', error),
        );
};